import React, { useState, useEffect } from "react";

import VerticallyModal from "../../../components/modal/VerticallyModal";
import { Row, Button } from "react-bootstrap";
import metamask from "../../../assets/images/metamask.png";
import walletconnectImg from "../../../assets/images/walletconnect.svg";
import { toast } from "react-toastify";
import { ToastOptions, FailureToast } from "../../../utils/constants";
import { useAppKit } from "@reown/appkit/react";
import { useAccount } from "wagmi";
import { useGlobal } from "../../../context/globalContext";

function ConnectModal(props) {
  const appKitModal = useAppKit();

  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  return <></>;
}

export default function WalletConnect(props) {
  return <ConnectModal {...props} />;
}
